module.exports = __webpack_public_path__ + "68fa1d2e993bdcb4185a73f90da4fb85.jpg";